export default __webpack_public_path__ + "static/media/AvenirMediumFont.04360129.ttf";